import { Col, Container, Row } from "react-bootstrap";
import { FC } from "react";
import { useProfile, useConfig, useSites } from "../api/hooks";
import { SiteResponse } from "../api/ApiClient";
import SiteMap from "./SiteMap";

const Locations = () => {
  const {
    data: profile,
    isLoading: profileLoading,
    error: profileError,
  } = useProfile();
  const {
    data: config,
    isLoading: configLoading,
    error: configError,
  } = useConfig();
  const {
    data: sites,
    isLoading: sitesLoading,
    error: sitesError,
  } = useSites();
  const apiKey = config?.googleMapsApi || "";

  // Debug logging
  // console.log("Locations Debug:", {
  //   profileLoading,
  //   configLoading,
  //   sitesLoading,
  //   profileError,
  //   configError,
  //   sitesError,
  //   profile: !!profile,
  //   sites: sites?.length || 0,
  //   config: !!config,
  //   apiKey: apiKey.length > 0,
  // });

  const setSelectedSite = (id: string) => {
    //console.log("Selected site", id);
  };

  if (profileLoading || configLoading || sitesLoading) {
    //console.log("Showing loading state");
    return <div>Loading locations...</div>;
  }

  if (profileError || configError || sitesError) {
    console.log("Showing error state", {
      profileError,
      configError,
      sitesError,
    });
    return (
      <div>
        Error loading locations:{" "}
        {profileError?.message || configError?.message || sitesError?.message}
      </div>
    );
  }

  if (!profile || !sites) {
    console.log("Showing no data state", {
      profile: !!profile,
      sites: !!sites,
    });
    return <div>No data available</div>;
  }

  // For now, show all available sites as potential permanent parking locations
  // In a real implementation, you might filter this based on user's permanent site assignments
  const permSites = sites || [];

  // console.log("Rendering locations with", permSites.length, "sites");

  return (
    <>
      {/* <Row className="gx-2 my-5">
        <Col>
          <h2>Available Parking Locations</h2>
          <>
            {permSites.map((site) => (
              <ParkingLocation site={site} key={site.id} />
            ))}
            {permSites.length === 0 && (
              <div>No parking locations available</div>
            )}
          </>
        </Col>
      </Row> */}


        <SiteMap
          apiKey={apiKey}
          sites={permSites}
          setSelectedSite={setSelectedSite}
        />

    </>
  );
};

const ParkingLocation: FC<{ site: SiteResponse }> = ({ site }) => {
  return (
    <Container className="g-3 my-3 py-2 bg-white reservation">
      <Row>
        <Col>{site.name}</Col>
      </Row>
      <Row>
        <Col>{site.address}</Col>
      </Row>
    </Container>
  );
};

export default Locations;
